const SECTION_META = {
  warmup: { label: "WARM-UP", color: "text-orange-400" },
  workout: { label: "WORKOUT", color: "text-volt" },
  cooldown: { label: "COOL-DOWN", color: "text-sky-400" },
};

const SECTION_ORDER = ["warmup", "workout", "cooldown"];

export default function PlanWeeks({ weeks, exMap }) {
  return (
    <div className="space-y-6">
      {weeks?.map((w, wi) => (
        <div key={`week-${w.week_index}-${wi}`} className="border border-border">
          <div className="bg-secondary px-4 py-3 flex justify-between">
            <div className="font-display text-xl font-black">WEEK {w.week_index}</div>
            {w.intent && <div className="label-mono">// {w.intent}</div>}
          </div>
          <div className="divide-y divide-border">
            {w.days?.map((d, di) => (
              <DayRow key={`d-${w.week_index}-${d.day}-${di}`} day={d} exMap={exMap} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

function DayRow({ day: d, exMap }) {
  // Bucket exercises by section, preserving order. Defaults to "workout".
  const sections = { warmup: [], workout: [], cooldown: [] };
  (d.exercises || []).forEach((ex) => {
    const key = sections[ex.section] ? ex.section : "workout";
    sections[key].push(ex);
  });
  const populatedSections = SECTION_ORDER.filter((s) => sections[s].length > 0);

  return (
    <div className="px-4 py-3 grid sm:grid-cols-[100px_140px_1fr] gap-3 items-start">
      <div className="font-display font-bold text-volt">DAY {d.day}</div>
      <div className="label-mono">{d.focus}</div>
      <div className="text-sm">
        {d.exercises?.length === 0 ? (
          <span className="text-muted-foreground">—</span>
        ) : populatedSections.length === 1 ? (
          <SectionList exercises={sections[populatedSections[0]]} exMap={exMap} />
        ) : (
          <div className="space-y-3">
            {populatedSections.map((s) => (
              <div key={s}>
                <div className={`label-mono text-[10px] mb-1 ${SECTION_META[s].color}`}>// {SECTION_META[s].label}</div>
                <SectionList exercises={sections[s]} exMap={exMap} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function SectionList({ exercises, exMap }) {
  return (
    <ul className="space-y-1">
      {exercises.map((ex, i) => (
        <li key={`${ex.exercise_id}-${i}`}>
          <span className="font-display font-bold uppercase">{exMap[ex.exercise_id]?.name || ex.exercise_id}</span>
          {ex.sets && <span className="text-muted-foreground"> · {ex.sets}x{ex.reps}</span>}
          {!ex.sets && ex.reps && <span className="text-muted-foreground"> · {ex.reps}</span>}
          {ex.weight && <span className="text-volt"> · {ex.weight}</span>}
        </li>
      ))}
    </ul>
  );
}
